import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  readonly headerId=4;
  getSubscriptionDetails = new BehaviorSubject<any>({})
  constructor(private http: HttpClient) { }
  getAllTags = () => {
    const headers = new HttpHeaders({
      headerId: this.headerId,
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/moduleTags`, null, {
      headers: headers,
    })
  }
  getAllCategories = () => {
    const headers = new HttpHeaders({
      headerId: this.headerId,
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/categories`, null, {
      headers: headers,
    })
  }
  getAllModules = () => {
    const headers = new HttpHeaders({
      headerId: this.headerId,
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/moduleTypes`, null, {
      headers: headers,
    })
  }
  getAllAnalyticsModules = (payload: any, source: any) => {
    let url;
    if(source == 'capability')
        url = "allModules";
    else
        url = "allDetailedModules";

    return this.http.post<any>(`${environment.apiUrl}/v1/${url}`, payload).pipe(shareReplay(1))
  }
  getAllHeaders = () => this.http.post<any>(`${environment.apiUrl}/v1/moduleTags`, null)
  markUnmarkFavourite(payload: any) {
    return this.http.post(`${environment.apiUrl}/v1/markUnmarkFavourite`, payload);
  }
  getAnalyticsDetailsById = (payload: any) => this.http.post<any>(`${environment.apiUrl}/v1/moduleDetails`, payload)
  
  getAllRegions = () => {
    const headers = new HttpHeaders({
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/regions`, null, {
      headers: headers,
    })
  }
  getAllBusinessLines = () => {
    const headers = new HttpHeaders({
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/businessLines`, null, {
      headers: headers,
    })
  }
  getFunctions = () => {
    const headers = new HttpHeaders({
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/functions`, null, {
      headers: headers,
    })
  }
   getProductLines = () => {
    const headers = new HttpHeaders({
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/productLines`, null, {
      headers: headers,
    })
  }
  getCategoryModules = () => {
    const headers = new HttpHeaders({
      headerId: this.headerId,
    });
    return this.http.post<any>(`${environment.apiUrl}/v1/categoryModules`, null, {
      headers: headers,
    })
  }
  getParametersByGroup(headerId: any) {
      let headers = new HttpHeaders().append('moduleId', headerId.toString());
      const requestOptions = { headers: headers };
      return this.http.post(
        `${environment.apiUrl}/v1/parametersByGroup`,
        null,
        requestOptions
      );
  }
  getValuesByParameters(headerId: any,payload:any) {
      let headers = new HttpHeaders().append('moduleId', headerId.toString());
      const requestOptions = { headers: headers };
      return this.http.post(
        `${environment.apiUrl}/v1/valuesByParameters`,
        payload,
        requestOptions
      );
  }
}
